export const enum ERoutes {
  AWARDS = 'awards',
  CANDIDATES = 'candidates',
  AWARD_CASE = 'award-case',
  AWARD_REQUEST = 'award-request',
  AWARD_REQUEST_ARCHIVE = 'award-request-archive',
  RESULTS = 'results',
  ORGANIZATIONS = 'organizations',
  DASHBOARD = 'dashboard',
  NPA = 'npa',
  DOC_REGISTRATION = 'doc-registration',
  WORK_INDUSTRY = 'work-industry',
  AWARD_REQUEST_CASE = 'award-request-case',
  AWARD_REASON = 'award-reason',
  PROTOCOLS = 'protocols',
}

export const UtilityRoutes = {
  CARD: 'card',
} as const;

export const DEFAULT_ROUTE = ERoutes.DASHBOARD;

const CATEGORY_ROUTE_SEGMENT_PREFIX: Partial<Record<ERoutes, string>> = {
  [ERoutes.AWARD_REQUEST]: 'request-',
  [ERoutes.AWARD_REQUEST_ARCHIVE]: 'request-archive-',
};

export const getCategoryRouteSegment = (
  module: ERoutes,
  categoryCode: string | null | undefined
): string => `${CATEGORY_ROUTE_SEGMENT_PREFIX[module] ?? ''}${categoryCode ?? ''}`;
